export default __webpack_public_path__ + "static/media/twitter-logo.7204471d.svg";